<template>
    <a id="logo" :href="link">
        <img :src="logo" class="h-[50px]"/>
    </a>
</template>

<script>
export default {
    name: 'logo',
    props: {
        logo: { type: String, default: '/static/img/LOGO-OCTOLO-H-NEW.svg' },
        link: { type: String, default: '/' },
    }
}
</script>
